import { ILogger, LoggerFactory } from '../../../helpers/helpers';
import { ITimeSeries } from './ITimeSeries';

export class TimeSeriesBase implements ITimeSeries {

    private _hasOwnAxis: boolean;
    private _isVisible: boolean;
    private _groupBase: d3.Selection<any>;
    private _yMin: number;
    private _yMax: number;
    private _loggerBase: ILogger;
    protected _serieState: number = 0;

    constructor() {
        this._loggerBase = LoggerFactory.getLogger('WideTech.Charting.timeSeriesBase', false, 1);
        this.hasOwnAxis(false);
    }

    hasOwnAxis(value?: boolean): boolean {
        if (value !== undefined && value !== null) {
            this._hasOwnAxis = value;
        }
        return this._hasOwnAxis;
    }

    yMin(value?: number): number {
        if (arguments.length) {
            this._yMin = value;
        }
        return this._yMin;
    }

    yMax(value?: number): number {
        if (arguments.length) {
            this._yMax = value;
        }
        return this._yMax;
    }

    initBase(container): d3.Selection<any> {
        this._loggerBase.debug('Initializing...');
        this._groupBase = container
            .append('g')
            .classed('series', true);
        this.isVisible(true);
        this._loggerBase.debug('Initialized.');
        return this._groupBase;
    }

    isVisible(value?: boolean): boolean {
        if (value !== null && value !== undefined) {
            this._isVisible = value;
            if (this._isVisible) {
                this._groupBase.style('visibility', 'visible');
            } else {
                this._groupBase.style('visibility', 'hidden');
            }
        }
        return this._isVisible;
    }

}